import ascfSdk from '@atomicservice/ascf-web-sdk'

/**
 * Taro 编译到鸿蒙元服务时，web-view 内导航必须走 has.ascfweb.*：
 * 1. H5 内部历史：history.back() / history.go(-1)
 * 2. 从 web-view 回到 Taro 宿主：has.ascfweb.navigateBack()
 * 3. 从 web-view 切到 Taro Tab 首页：has.ascfweb.switchTab()
 * 4. 从 web-view 新开宿主页（如再开一个 webview）：has.ascfweb.navigateTo()
 *    （Taro.navigateBack / Taro.switchTab 映射的是宿主页 has.*，不能在 H5 里当 web-view 导航用）
 */
function getAscfHas(methodName) {
  if (typeof window !== 'undefined' && typeof window.has?.ascfweb?.[methodName] === 'function') {
    return window.has
  }
  return ascfSdk
}

/**
 * 从 web-view 内 H5 返回 Taro / ASCF 宿主页
 * @param {number} [delta=1]
 * @returns {boolean} 是否已发出返回指令
 */
export function ascfWebNavigateBack(delta = 1) {
  try {
    const has = getAscfHas('navigateBack')
    if (typeof has?.ascfweb?.navigateBack !== 'function') {
      console.error('has.ascfweb.navigateBack is unavailable')
      return false
    }
    has.ascfweb.navigateBack({ delta })
    return true
  } catch (error) {
    console.error('has.ascfweb.navigateBack failed', error)
    return false
  }
}

/**
 * 从 web-view 内 H5 新开 / 替换 Taro 宿主页（对齐微信 wx.miniProgram.navigateTo）
 * @param {string} url 宿主页路径，如 /pages/webview/index?url=...
 * @param {{ replace?: boolean }} [options]
 * @returns {boolean} 是否已发出跳转指令
 */
export function ascfWebNavigateTo(url, { replace = false } = {}) {
  const methodName = replace ? 'redirectTo' : 'navigateTo'
  try {
    const has = getAscfHas(methodName)
    if (typeof has?.ascfweb?.[methodName] !== 'function') {
      console.error(`has.ascfweb.${methodName} is unavailable`)
      return false
    }
    has.ascfweb[methodName]({ url })
    return true
  } catch (error) {
    console.error(`has.ascfweb.${methodName} failed`, error)
    return false
  }
}

/**
 * 从 web-view 内 H5 切换到 Taro 宿主 Tab 页（如首页）
 * @param {string} url Tab 路径，默认元服务/小程序首页
 * @returns {boolean} 是否已发出跳转指令
 */
export function ascfWebSwitchTab(url = '/pages/index/index') {
  try {
    const has = getAscfHas('switchTab')
    if (typeof has?.ascfweb?.switchTab !== 'function') {
      console.error('has.ascfweb.switchTab is unavailable')
      return false
    }
    has.ascfweb.switchTab({ url })
    return true
  } catch (error) {
    console.error('has.ascfweb.switchTab failed', error)
    return false
  }
}
